angular.module('app').directive('eqField', function() {
    return {
        'restrict': 'A',
        'scope': {
            'ctrl': '=eqField',
            'op': '@eqOp',
            'name': '@eqName',
            'watch': '@eqWatch',
            'remoteName': '@eqRemoteName'
        },
        'link': function(scope, elem, attr, ctrl) {
            scope.ctrl.eqFields.push({
                'localName': scope.name,
                'remoteName': scope.remoteName || scope.name,
                'op': scope.op || 'eq'
            });
        },
        'controller': function($scope) {
            if($scope.watch) {
                $scope.$watch(
                    function() { return $scope.ctrl.query[$scope.watch]; },
                    function() {
                        $scope.ctrl.load();
                    }
                );
            }
        }
    };
});
